export default __webpack_public_path__ + "static/media/hello_hand.32c4c99c.png";